'use strict';

angular.module('recomModule', []);